import React, { useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import CollapseText, { Ref } from './CollapseText';
import Trans from 'components/Common/Translation/Trans';
import { DEFAULT_AFIBEL_SEPARATOR_CHARACTER } from 'services/product';

import styles from '../ProductDescription.module.scss';

export type Props = {
  attrCode: string;
  content: string;
  label?: string | false;
  enableCollapseMode?: boolean;
};

function DefaultItem({
  attrCode,
  content,
  label,
  enableCollapseMode,
}: Props): JSX.Element {
  const { t } = useTranslation(['productPage']);
  const collapseTextRef = useRef<Ref>(null);

  function getHeading(headingLabel: string): JSX.Element {
    return (
      <Trans
        i18nKey={'LABEL_ATTR_HEADING_FORMAT'}
        namespace={'productPage'}
        additionalComponents={{
          heading: <h3 className={styles.heading} />,
          wrapper: <div className={styles.headingWrapper} />,
        }}
        values={{
          label: headingLabel,
        }}
      />
    );
  }

  function generateLabelName(attrName: string) {
    return attrName
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
      .toUpperCase();
  }

  function clickHandler() {
    collapseTextRef.current?.toggleCollapse();
  }

  function capitalizeFirstLetter(content: string) {
    return content.charAt(0).toUpperCase() + content.slice(1);
  }

  const mustShowLabel = label !== false;
  const newLabel = mustShowLabel
    ? label || (t(`LABEL_ATTR_${generateLabelName(attrCode)}`) as string)
    : undefined;

  let lineContent = '';
  if (newLabel) {
    lineContent +=
      ReactDOMServer.renderToStaticMarkup(getHeading(newLabel)) + ' ';
  }

  lineContent += ReactDOMServer.renderToStaticMarkup(
    <span>
      {attrCode === 'nomModele'
        ? content.toUpperCase()
        : capitalizeFirstLetter(content).replaceAll(
            DEFAULT_AFIBEL_SEPARATOR_CHARACTER,
            ', '
          )}
    </span>
  );

  return (
    <div
      className={classNames(styles[attrCode], styles.attrLines)}
      onClick={clickHandler}
    >
      {enableCollapseMode && (
        <CollapseText ref={collapseTextRef}>
          <p
            dangerouslySetInnerHTML={{
              __html: lineContent,
            }}
            className={styles.content}
          />
        </CollapseText>
      )}
      {!enableCollapseMode && (
        <p
          dangerouslySetInnerHTML={{
            __html: lineContent,
          }}
          className={styles.content}
        />
      )}
    </div>
  );
}

export default React.memo(DefaultItem);
